export enum SettingsActionFieldNames {
  IsRequired = 'isRequired',
  IsHiddenInFormPDFExports = 'isHiddenInFormPDFExports',
}
